import http from '../http'

export default {
  // paifa集群配置
  getClusterConfig(data: object = {}) {
    return http.post('/config/cluster/config', data)
  },
}
